import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cec31a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "history" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "box_list",
  "data-aos": "fade-up"
}
const _hoisted_4 = {
  key: 0,
  class: "item i_year"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ">>", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ">>", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1 /* HOISTED */))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item i_year" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, {
        level: 2,
        "data-aos": "fade-right"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Milestones ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Swiper, {
          slidesPerView: "auto",
          speed: 600,
          navigation: {prevEl:'.button_prev',nextEl:'.button_next',disabledClass:'button_disabled'}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tab.list, (item, index) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, null, {
                default: _withCtx(() => [
                  (item.type==='year')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (index!==0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_5,
                              _hoisted_6
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(" " + _toDisplayString(item.content.title) + " ", 1 /* TEXT */),
                        _hoisted_7,
                        _hoisted_8
                      ]))
                    : (item.type==='event')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["item i_event", `i_${item.position}`])
                        }, [
                          _hoisted_9,
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createVNode(_component_a_typography_title, { level: 5 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.content.title), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            _createVNode(_component_a_typography_paragraph, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content.list, (v) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(v), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                          ])
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 256 /* UNKEYED_FRAGMENT */)),
            _createVNode(_component_SwiperSlide, null, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["navigation"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_prev"
        }),
        _createVNode(_component_a_button, {
          type: "link",
          class: "button_next"
        })
      ])
    ])
  ]))
}